import { render, staticRenderFns } from "./StageCreateUpdate.vue?vue&type=template&id=bfdb08b6&"
import script from "./StageCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./StageCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports